export const webhookTypes = [
  {
    value: 'collect_session.complete',
    text: 'Collect session completed',
  },
  {
    value: 'document_state_changed',
    text: 'Document state changed',
  },
  {
    value: 'customer_approval_status_changed',
    text: 'Customer approval status changed',
  },
  {
    value: 'document_state_changed_minimal',
    text: 'Document state changed minimal',
  },
  {
    value: 'customer_processed',
    text: 'Customer processed',
  },
];

export const documentReviewAgentWebhookTypes = [
  {
    value: 'document_review_agent_run_status_changed',
    text: 'Document Review Agent run status changed',
  },
];

export const businessComplianceAgentWebhookTypes = [
  {
    value: 'business_compliance_agent_run_status_changed',
    text: 'Business Compliance Agent run status changed',
  },
];

export const processingJobWebhookTypes = [
  {
    value: 'processing_job_finished',
    text: 'Processing job finished',
  },
];

export const deprecatedWebhookTypes = [
  {
    value: 'document_state_changed_advanced',
    text: 'Document state changed (advanced) (deprecated)',
    disabled: true,
  },
  {
    value: 'document_processed',
    text: 'Document processed (deprecated)',
    disabled: true,
  },
];

export const documentProgressWebhookTypes = [
  {
    value: 'document_progress',
    text: 'Document progress',
  },
];
